import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { getUserData } from '@/auth/utils'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrupoUsuarioList() {
  // Use toast
  const toast = useToast()

  const refGrupoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'item_nome', sortable: true, label: 'Nome Produto' },
    { key: 'quantidade', sortable: true, label: 'Quantidade' },
    { key: 'preco', sortable: true, label: 'Preço Venda' },
    { key: 'comissao', sortable: true, label: 'Comissão' },
    { key: 'categoria', sortable: true, label: 'Categoria' },
    { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'ativo', sortable: true, label: 'Status' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalClientes = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('')
  const categoryFilter = ref('')

  // otions
  const categoriaOptions = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refGrupoListTable.value ? refGrupoListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalClientes.value,
    }
  })

  const refetchData = () => {
    refGrupoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, isSortDirDesc, statusFilter, categoryFilter], () => {
    refetchData()
  })

  const getStatus = status => {
    let alterStatus = null
    if (['1', 1, 'active', 'ativo', true, 'true'].indexOf(status) !== -1) {
      alterStatus = 1
    }
    if (['0', 0, 'inactive', 'inativo', false, 'false'].indexOf(status) !== -1) {
      alterStatus = 0
    }
    return alterStatus
  }

  const findAll = (ctx, callback) => {
    const userData = getUserData()
    store
      .dispatch('appAdmCategory/fetchCategories')
      .then(response => {
        const { categories } = response.data
        categoriaOptions.value = categories
      })
    store
      .dispatch('appAdmProdutos/findAll', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        ativo: getStatus(statusFilter.value) || null,
        id_categoria: categoryFilter.value || null,
        categoria_usuario: userData?.afiliado?.categoria?.id || null,
      })
      .then(response => {
        const { data, ...paginario } = response.data
        const itemsComPreco = data.filter(item =>
          item.tabela_preco_itens &&
          item.tabela_preco_itens.length > 0 &&
          item.tabela_preco_itens.some(p => p.preco_venda !== null && p.preco_venda !== undefined && Number(p.preco_venda) > 0)
        )
        callback(itemsComPreco)
        perPage.value = paginario.perPage
        currentPage.value = paginario.page
        totalClientes.value = paginario.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === null) return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'primary'
  }

  return {
    findAll,
    tableColumns,
    perPage,
    currentPage,
    totalClientes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGrupoListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    statusFilter,
    categoryFilter,
    categoriaOptions,
  }
}
